export function schoolReducer(
  state = {
    loading: true,
    result: [],
    schoolResult: null,
    error: null
  },
  action
) {
  switch (action.type) {
    case "FETCH_SCHOOL_TEACHERS_BEGIN": {
      return { ...state, loading: true };
    }
    case "FETCH_SCHOOL_TEACHERS_REJECTED": {
      return { ...state, loading: false, error: action.payload };
    }
    case "FETCH_SCHOOL_TEACHERS_FULFILLED": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case "FETCH_SCHOOLS_BEGIN": {
      return { ...state, loading: true };
    }
    case "FETCH_SCHOOLS_REJECTED": {
      return { ...state, loading: false, error: action.payload };
    }
    case "FETCH_SCHOOLS_FULFILLED": {
      return {
        ...state,
        loading: false,
        schoolResult: action.payload
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
